__turbopack_context__.v({
  "className": "yu6R2a_className",
});
